import React, { PropTypes } from "react";
import { Link } from "react-router";
import { FormattedMessage } from "react-intl";

import { MANAGER } from "../../../../../utils/Roles";
import userHasAccess from "../../../../../utils/userHasAccess";

const BlocNav = (props) => {
  const { blocId } = props;

  const getMenuItems = () => {
    return [
      {
        requiredRole: MANAGER,
        to: `/dashboard/admin/blocs/${blocId}/clients`,
        title: "admin.blocs.bloc.pages.clients",
      },
    ];
  };

  return (
    <div className="sub-nav">
      <ul>
        {getMenuItems()
          .filter((menu) => userHasAccess(menu.requiredRole))
          .map((menu, index) => {
            return (
              <li key={index}>
                <Link to={menu.to} activeClassName="active">
                  <FormattedMessage id={menu.title} />
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

BlocNav.propTypes = {
  blocId: PropTypes.string,
};

export default BlocNav;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/BlocNav.js